import { sub } from 'date-fns';

/**
 * Returns the default selected date (yesterday, at midnight).
 */
export function getDefaultSelectedDate(): Date {
  const d = sub(new Date(), { days: 1 });
  d.setHours(0, 0, 0, 0);
  return d;
}
